import { gql } from '@apollo/client';

export const CREATE_OBJECTIVE_MUTATION = gql`
    mutation createObjective( $input:CreateObjectiveInput! ) {
        result: createObjective( input: $input ) {
            id
            locales {
                code,
                name,
                description
            }
            points
        }
    }
`;